import browserdetect from '../browserdetect/browserdetect';

const customEvent = {
  createCustomEvent (eventName, options) {
    if (browserdetect.isIE) {
      const event = document.createEvent('CustomEvent');
      let bubbles = false;
      if (options) {
        bubbles = options.bubbles || false;
      }
      event.initEvent(eventName, bubbles, true);
      return event;
    }
    return new CustomEvent(eventName, options || {});
  },
};

export default customEvent;



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/common/js/customevent/customevent.js